var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', [_vm.user && _vm.user.isVerified ? _c('header-app') : _vm._e(), _c('v-main', [_c('router-view')], 1), _c('snackbar'), _c('confirmation-dialog')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }